import React from 'react';
import PatientManagement from './PatientManagement';

function PatientFiles() {
    return <PatientManagement />;
}

export default PatientFiles;
